<template>
  <Teleport to="body">
    <div class="fixed w-96 left-0 right-0 z-50 mx-auto">
      <TransitionGroup name="message-transition" @leave="onLeave">
        <div
          v-for="message in messagesFiltered"
          :key="message.key"
          class="border border-opacity-50 rounded shadow mt-4 px-4 py-2 transition-all duration-700"
          :class="message.color"
        >
          {{ message.text }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

const messages = ref(props.modelValue)
const messagesFiltered = computed(() => messages.value.slice(-4))
watch(messages, (val) => emit('update:modelValue', val))
watch(
  () => props.modelValue,
  (val) => (messages.value = val),
)

let timer

onMounted(() => {
  timer = setInterval(() => {
    messages.value.forEach((message, index) => {
      message.time -= 10
      if (message.time <= 0) {
        messages.value.splice(index, 1)
      }
    })
  }, 10)
})
onUnmounted(() => {
  clearInterval(timer)
})

function onLeave(el) {
  el.style.left = `${el.offsetLeft}px`
  el.style.top = `${el.offsetTop}px`
  el.style.width = getComputedStyle(el).width
  el.style.height = getComputedStyle(el).height
  el.style.position = 'absolute'
}
</script>

<style lang="postcss" scoped>
.message-transition-enter-from {
  @apply opacity-0 transform -translate-y-3;
}
.message-transition-leave-active {
  @apply opacity-0 z-0 transform -translate-y-3 scale-75;
}
</style>
